<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>商品詳細編集</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          :to="{ name: 'EditProduct', params: {id: $route.params.id}}"
        >
          商品へ戻る
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="product_headers"
          :items="product_item"
          hide-default-footer
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <v-btn
          class="title-btn red white--text"
          @click="newItem"
        >
          商品明細を追加する
        </v-btn>
        <v-dialog v-model="dialog" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">商品明細登録</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="*商品名"
                      v-model="item.name"
                      :error-messages="validation_errors.name"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="*価格"
                      v-model="item.price"
                      :error-messages="validation_errors.price"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-text-field
                      label="基準日"
                      v-model="item.base_date"
                      :error-messages="validation_errors.base_date"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-select
                      label="消費税区分"
                      :items=$store.getters.taxTypes
                      item-text="name"
                      item-value="id"
                      v-model="item.taxtype_id"
                      :error-messages="validation_errors.taxtype_id"
                      readonly
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    sm="6"
                  >
                    <v-switch
                      label="オンライン販売"
                      v-model="item.online_sales"
                      :error-messages="validation_errors.online_sales"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    sm="6"
                  >
                    <v-switch
                      label="サブスクリプション"
                      v-model="item.is_subscription"
                      :error-messages="validation_errors.is_subscription"
                    >
                    </v-switch>
                  </v-col>
                  <v-col
                    v-if="item.is_subscription"
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="契約期間(月)"
                      v-model="item.contract_period"
                      :error-messages="validation_errors.contract_period"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    v-if="item.is_subscription"
                    cols="12"
                    md="4"
                    sm="6"
                  >
                    <v-switch
                      label="Webアカウント"
                      v-model="item.with_webaccount"
                      :error-messages="validation_errors.with_webaccount"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      color="primary"
                      dark
                      @click="openDeliveryItemDialog"
                    >
                      <template v-if="item.is_subscription">対象配送製品を追加する</template>
                      <template v-else>対象配送製品明細を追加する</template>
                    </v-btn>
                    <v-dialog v-model="deliveryitem_dialog" persistent>
                      <v-card>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                md="3"
                                sm="6"
                              >
                                <v-select
                                  label="*配送製品カテゴリ"
                                  :items="$store.getters.deliveryItemCategories"
                                  item-text="name"
                                  item-value="id"
                                  v-model="deliveryitemcategory_id"
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                sm="6"
                              >
                                <v-select
                                  label="*配送製品"
                                  :items="deliveryitems"
                                  item-text="name"
                                  item-value="id"
                                  v-model="deliveryitem_id"
                                ></v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                sm="6"
                                v-if="!item.is_subscription"
                              >
                                <v-select
                                  label="*配送製品明細"
                                  :items="deliveryitemdetails"
                                  item-text="name"
                                  item-value="id"
                                  v-model="deliveryitemdetail_id"
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                md="2"
                                sm="6"
                              >
                              <v-btn
                                @click="addDliveryItem"
                                color="primary">選択</v-btn>
                              </v-col>
                              <v-col
                                cols="12"
                                md="2"
                                sm="6"
                              >
                              <v-btn
                                @click="deliveryitem_dialog = false"
                                color="default">キャンセル</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
                <v-row v-if="item.deliveryitemdetails && !item.is_subscription">
                  <v-col>
                    <v-data-table
                      hide-default-footer
                      :headers="item_headers"
                      :items="item.deliveryitemdetails"
                      :items-per-page="50"
                      :footer-props="footer_props"
                      disable-sort
                      disable-filtering
                      locale="ja-jp"
                      loading-text="読込中"
                      no-data-text="データがありません。"
                      :options.sync="options"
                    >
                    <template v-slot:item.action="{ item }">
                      <v-btn
                        small
                        color="default"
                        @click="deleteDeliveryItemDetail(item)"
                      >
                        削除
                      </v-btn>
                    </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row v-if="item.deliveryitems && item.is_subscription">
                  <v-col>
                    <v-data-table
                      hide-default-footer
                      :headers="item_headers"
                      :items="item.deliveryitems"
                      :items-per-page="50"
                      :footer-props="footer_props"
                      disable-sort
                      disable-filtering
                      locale="ja-jp"
                      loading-text="読込中"
                      no-data-text="データがありません。"
                    >
                    <template v-slot:item.action="{ item }">
                      <v-btn
                        small
                        color="default"
                        @click="deleteDeliveryItem(item)"
                      >
                        削除
                      </v-btn>
                    </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row v-if="item.with_webaccount">
                  <v-col>
                    <v-btn
                      color="primary"
                      dark
                      @click="openWebMediaDialog"
                    >
                      Webメディアを追加する
                    </v-btn>
                    <v-dialog v-model="webmedia_dialog" persistent>
                      <v-card>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                md="3"
                                sm="6"
                              >
                                <v-select
                                  label="*Webメディア"
                                  :items="webMedia"
                                  item-text="name"
                                  item-value="id"
                                  v-model="webmedia_id"
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                md="2"
                                sm="6"
                              >
                              <v-btn
                                @click="addWebMedia"
                                color="primary">選択</v-btn>
                              </v-col>
                              <v-col
                                cols="12"
                                md="2"
                                sm="6"
                              >
                              <v-btn
                                @click="webmedia_dialog = false"
                                color="default">キャンセル</v-btn>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
                <v-row v-if="item.webmedias && item.with_webaccount">
                  <v-col>
                    <v-data-table
                      hide-default-footer
                      :headers="item_headers"
                      :items="item.webmedias"
                      :items-per-page="50"
                      :footer-props="footer_props"
                      disable-sort
                      disable-filtering
                      locale="ja-jp"
                      loading-text="読込中"
                      no-data-text="データがありません。"
                      :options.sync="options"
                    >
                    <template v-slot:item.action="{ item }">
                      <v-btn
                        small
                        color="default"
                        @click="deleteWebMedia(item)"
                      >
                        削除
                      </v-btn>
                    </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    sm="8"
                  >
                    <v-text-field
                      label="最終更新者"
                      v-model="item.updated_by"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="最終更新日"
                      v-model="item.updated_at"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    class="red white--text"
                    @click="save"
                  >
                    保存する
                  </v-btn></v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    class="default"
                    @click="dialog = false"
                  >キャンセル</v-btn></v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="3"
      >
        <v-text-field
          label="検索"
          dense
          v-model="search"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="50"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          :search="search"
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            color="default"
            small
            @click="editItem(item.id)"
          >
            編集
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="商品明細削除"
          message="商品明細を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteProductDetail"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      loading: false,
      search: "",
      dialog: false,
      deliveryitem_dialog: false,
      webmedia_dialog: false,
      product_headers: [
        {text: "商品カテゴリ", value: "productcategory.name"},
        {text: "商品コード", value: "cd"},
        {text: "商品名", value: "name"},
      ],
      product_item: [],
      headers: [
        {text: "ID", value: "id"},
        {text: "名称", value: "name"},
        {text: "価格", value: "price"},
        {text: "消費税区分", value: "taxtype.name"},
        {text: "サブスクリプション", value: "is_subscription"},
        {text: "操作", value: "action", width: "130px"},
      ],
      item_headers: [
        {text: "名称", value: "name"},
        {text: "削除", value: "action"},
      ],
      item: {},
      item_default: {
        deliveryitems: null,
        deliveryitem_ids: null,
        deliveryitemdetails: null,
        deliveryitemdetail_ids: null,
        webmedias: null,
        webmedia_ids: null,
        taxtype_id: 2,
      },
      deliveryitemcategory_id: null,
      deliveryitem_id: null,
      deliveryitemdetail_id: null,
      webmedia_id: null,
      validation_errors: {},
      items: [],
      options: {},
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      deleteItem: {},
      deliveryitems: [],
      deliveryitemdetails: [],
      webMedia: [],
    }
  },
  created() {
    this.getProductItem();
    this.getProductItemDetails();
    this.getWebMedia();
  },
  watch: {
    'deliveryitemcategory_id': async function(val) {
      await this.loadDeliveryItems(val);
    },
    'deliveryitem_id': async function(val) {
      await this.loadDeliveryItemDetails(val);
    }
  },
  methods: {
    async getProductItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.product_item = [response.data]
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'ProductList'}).catch(()=>{});
      }
    },
    async getProductItemDetails() {
      this.loading = true;
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/${this.$route.params.id}/details/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.items = response.data;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'ProductList'}).catch(()=>{});
      }
      this.loading = false;
    },
    async getWebMedia() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/webmedia/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.webMedia = response.data;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'ProductList'}).catch(()=>{});
      }
    },
    newItem() {
      this.item = Object.assign({}, {'new': true, 'product_id': this.$route.params.id}, this.item_default);
      this.item.webmedia_ids = [];
      this.item.deliveryitem_ids = [];
      this.item.deliveryitemdetail_ids = [];
      console.log(this.item)
      this.validation_errors = false;
      this.dialog = true;
    },
    editItem(idx) {
      console.log(idx);
      this.item = this.items.filter((item) => item.id == idx)[0];
      console.log(this.item);
      this.validation_errors = false;
      this.dialog = true;
    },
    openDeliveryItemDialog() {
      this.deliveryitemcategory_id = null;
      this.deliveryitem_id = null;
      this.deliveryitemdetail_id = null;
      this.deliveryitem_dialog = true;
    },
    openWebMediaDialog() {
      this.webmedia_dialog = true;
    },
    async loadDeliveryItems(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/`,
            {
              params: {'deliveryitemcategory': val},
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.deliveryitems = response.data.results;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.deliveryitems = []
      }
    },
    async loadDeliveryItemDetails(val) {
      if (val) {
        try {
          const response = await this.$axios.get(
            `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${val}/details/`,
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          )
          this.deliveryitemdetails = response.data;
        } catch(error) {
          const error_status = error.response.status;
          if (error_status == 401) {
            this.$store.dispatch('userLogout');
          }
          this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        }
      } else {
        this.deliveryitemdetails = [];
      }
    },
    addDliveryItem() {
      if (this.item.is_subscription && this.deliveryitem_id) {
        const deliveryitem = this.deliveryitems.filter(item => item.id == this.deliveryitem_id)[0];
        if (!this.item.deliveryitems) {
          this.item.deliveryitems = [];
          this.item.deliveryitem_ids = [];
        }
        this.item.deliveryitems.push(deliveryitem);
        this.item.deliveryitem_ids.push(this.deliveryitem_id);
        this.deliveryitem_dialog = false;
      } else if (!this.item.is_subscription && this.deliveryitemdetail_id) {
        const deliveryitemdetail = this.deliveryitemdetails.filter(item => item.id == this.deliveryitemdetail_id)[0];
        if (!this.item.deliveryitemdetails) {
          this.item.deliveryitemdetails = [];
          this.item.deliveryitemdetail_ids = [];
        }
        this.item.deliveryitemdetails.push(deliveryitemdetail);
        this.item.deliveryitemdetail_ids.push(this.deliveryitemdetail_id);
        this.deliveryitem_dialog = false;
      }
    },
    addWebMedia() {
        if (!this.webmedia_id) {
          return;
        }
        const webmedia = this.webMedia.filter(item => item.id == this.webmedia_id)[0];
        if (!this.item.webmedias) {
          this.item.webmedias = [];
          this.item.webmedia_ids = [];
        }
        this.item.webmedias.push(webmedia);
        this.item.webmedia_ids.push(this.webmedia_id);
        this.webmedia_dialog = false;
    },
    deleteDeliveryItem(item) {
      this.item.deliveryitems = this.item.deliveryitems.filter(x => x.id != item.id);
      this.item.deliveryitem_ids = this.item.deliveryitem_ids.filter(x => x != item.id);
    },
    deleteWebMedia(item) {
      this.item.webmedias = this.item.webmedias.filter(x => x.id != item.id);
      this.item.webmedia_ids = this.item.webmedia_ids.filter(x => x != item.id);
    },
    deleteDeliveryItemDetail(item) {
      this.item.deliveryitemdetails = this.item.deliveryitemdetails.filter(x => x.id != item.id);
      this.item.deliveryitemdetail_ids = this.item.deliveryitemdetail_ids.filter(x => x != item.id);
    },
    async save() {
      if (this.item.new) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/${this.$route.params.id}/details/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {},
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.getProductItemDetails();
        this.dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
    async update() {
      try {
        const response = await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/${this.$route.params.id}/details/${this.item.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {},
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        this.getProductItemDetails();
        this.dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.resopnse.data;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteProductDetail() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/${this.$route.params.id}/details/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getProductItemDetails();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    }
  }
}
</script>